let BACKEND_SERVER = null;
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BACKEND_SERVER) {
    BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {
    //BACKEND_SERVER = 'http://localhost:5000/';
    BACKEND_SERVER = 'http://localhost:13371/';
}

export const API_SERVER = BACKEND_SERVER;